'use strict';
/*
* Novicell master
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var novicell = novicell || {};
var fragt = fragt || {};

// Document ready
document.addEventListener('DOMContentLoaded', function() {
    svg4everybody(); // Fix SVG spritemap in IE/Edge
    anime();
    novicell.backgroundVideo.init();
    novicell.mobileFooter.init();
    novicell.search.init();
    //novicell.cookieInfo.init();

    fragt.counterSection.init();
    fragt.forms.init();
    fragt.map.init();
    fragt.quoteSection.init();
    fragt.tracktrace.init();
    fragt.newsListView.init();

    fragt.languageSelector.init();
    fragt.addBoxClass.init();
    fragt.fileUpload.init();

    fragt.tariffs.init();

    fragt.contactButtons.init();
});

window.addEventListener('smartresize', function (elem) {
    novicell.backgroundVideo.init();
}, false);

window.addEventListener('scroll', function() {
    fragt.counterSection.init();
}, true);

window.addEventListener('load', function() {
    fragt.sliders.init();
    fragt.overlay.init();

    // Setting timeout to let laggy-content load for height to be calculated right
    setTimeout(function() {
        fragt.accordion.init();
    }, 1500);
});
